import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function({ email, password, firstName, lastName }) {
  const api = inject(ApiService)
  return await api.request({
    url: '/api/accounts',
    method: 'POST',
    data: { email, password, firstName, lastName }
  })
}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/createAccount.js